import React, { useState } from "react";

import { FormattedMessage, useIntl } from "react-intl";

import Heading from "@atlaskit/heading";
import { Stack, xcss } from "@atlaskit/primitives";

import { ResourceCard } from "../resource-card";

import { messages } from "./messages";
import { MigrationResources } from "./migration-resources";
import { RequestAssistanceModal } from "./request-assistance-modal";

const FastshiftResourcesSectionStyles = xcss({
    width: "430px"
});

export const FastshiftResourcesSection: React.FC = () => {
    const intl = useIntl();

    const [isModalOpen, setIsModalOpen] = useState(false);

    const fastshiftAssistanceCardOnClick = () => {
        setIsModalOpen(true);
    };

    return (
        <Stack space="space.300" xcss={FastshiftResourcesSectionStyles}>
            <RequestAssistanceModal
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
            />
            <Stack space="space.200">
                <Heading size="small">
                    <FormattedMessage
                        {...messages.fastshiftAssistanceSectionTitle}
                    />
                </Heading>
                <ResourceCard
                    title={intl.formatMessage(
                        messages.fastshiftAssistanceCardTitle
                    )}
                    description={intl.formatMessage(
                        messages.fastshiftAssistanceCardDescription
                    )}
                    buttonText={intl.formatMessage(
                        messages.fastshiftAssistanceCardButton
                    )}
                    onClick={fastshiftAssistanceCardOnClick}
                    isHighlighted={true}
                />
            </Stack>
            <MigrationResources />
        </Stack>
    );
};
